
import {defineComponent, PropType} from 'vue'
import {PromotionType} from "../../../../../common/components/ob1/models/Price";

export default defineComponent({
    name: "AdditionalPrice",
    props: {
        title: {
            type: String,
            required: true,
        },
        initialPrice: {
            type: String,
            required: true,
        },
        promotionPrice: {
            type: String,
            required: true,
        },
        promotionDuration: {
            type: Number,
            required: true,
        },
        promotionType: {
            type: Object as PropType<PromotionType>,
            required: true,
        },
    }
})
